import camera from '@/mixins/Customizer/SceneSetup/Camera';
import floor from '@/mixins/Customizer/SceneSetup/Floor';
import stitches from '@/mixins/Customizer/SceneSetup/Stitches';
import raytracer from '@/mixins/Customizer/SceneSetup/Raytracer';

export default {
  mixins: [ camera, floor, stitches, raytracer ]
};
